;
(function() {
    var $ = document.querySelector.bind(document);
    var alert_btn = "";
    var popAlert = function() {
        var _this = this;
        this.body = document.getElementsByTagName("body")[0];　
    }
    popAlert.prototype = {
        init:function(){
            this.createStyle();
            this.createDom();
            this.addEvent();
            window.alert = this.showText.bind(this);
        },
        createDom: function() {
            var strDom = '<span class="alert_cha">&times;</span><p class="alert_title"></p><br/><span href="javascript:;" class="alert_btn">OK</span>';
            this.pop = document.createElement("div");
            this.pop.setAttribute('class', 'pop');
            this.body.appendChild(this.pop);
            this.alert = document.createElement("div");
            this.alert.id = 'alert';
            this.alert.innerHTML = strDom;
            this.textDom = this.alert.querySelector('.alert_title');
            alert_btn = this.alert.querySelector('.alert_btn');
            this.alert_cha = this.alert.querySelector('.alert_cha');
            this.body.appendChild(this.alert);
        },
        createStyle: function() {
            var style = document.createElement("style");　　
            var cssText = '#alert{width:360px;position:fixed;top:50%;margin-top:-74px;text-align:center;display:none;padding-bottom:10px;background-color:#fff;left:0;right:0;margin-left:auto;margin-right:auto;z-index:9999}.pop{z-index:9999;position:fixed;left:0;top:0;background-color:#000;opacity:.6;width:100%;height:100%;display:none}#alert .alert_cha{font-size:30px;line-height: 1;cursor:pointer;-webkit-transition:all .1s ease-in;transition:all .1s ease-in;position:absolute;top:0;right:8px}#alert .alert_cha:hover{opacity:.6;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}#alert .alert_title{margin-top:10px;margin-bottom: 0;padding:20px;line-height:26px;box-sizing:border-box;display:inline-block;max-width:360px;min-width:5px;text-align:center;font-size:16px}#alert .alert_btn{padding:6px 12px;font-size:14px;line-height:1.4;text-align:center;vertical-align:middle;border:1px solid #ccc;border-radius:4px;display:inline-block;color:#000}#alert .alert_btn:hover{text-decoration:none;background-color:#e6e6e6}@media (max-width:370px){#alert{width:300px}}';
            style.type = "text/css";　　
            try {　　　　
                style.appendChild(document.createTextNode(cssText));　　
            } catch (ex) {　　　　
                style.styleSheet.cssText = cssText; /*兼容IE*/ 　　
            }　　　
            this.body.appendChild(style);
        },
        showText: function(text, btnText) {
            this.textDom.innerHTML = text;
            if(btnText){
                alert_btn.innerText = btnText;
            }else{
                alert_btn.innerText = 'OK';
            }
            this.alert.style.display = 'block';
            this.pop.style.display = 'block';
            return this.__proto__
        },
        okBtn: function(fn){
            alert_btn.addEventListener('click', fn, {once: true});
        },
        addEvent: function(){
            var _this = this;
            this.alert_cha.addEventListener('click', function(){
                _this.alert.style.display = 'none';
                _this.pop.style.display = 'none';
            }, false);
            alert_btn.addEventListener('click', function(){
                _this.alert.style.display = 'none';
                _this.pop.style.display = 'none';
            }, false);
        }
    }
    new popAlert().init();
})();
